<template>
    <div>
        <el-dialog
            title="真诚耐心，沟通无碍！"
            :center="true"
            :visible.sync="openData.state"
            width="750"
            :close-on-click-modal="false"
            :before-close="handleClose"
        >
            <img src="../../../assets/logo.png" class="icon" alt="" />
            <div class="mainBox">
                <div class="mainLeft">
                    <div class="mainForm">
                        <el-form
                            :model="addForm"
                            status-icon
                            :rules="rules"
                            ref="ruleForm"
                            label-width="100px"
                            class="demo-ruleForm"
                        >
                            <el-form-item label="沟通类型：" prop="calltype">
                                <el-select
                                    v-model="addForm.calltype"
                                    placeholder="请选择沟通类型"
                                    ref="selectType"
                                >
                                    <el-option
                                        v-for="(item, index) in contactList"
                                        :key="index"
                                        :label="item.name"
                                        :value="item.id"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="话务小结：" prop="remark">
                                <el-input
                                    type="textarea"
                                    :rows="4"
                                    placeholder="请输入内容"
                                    v-model="addForm.remark"
                                >
                                </el-input>
                            </el-form-item>
                            <div class="mainTable">
                                <div class="chooseTab">
                                    <p class="name">通话记录</p>
                                    <p class="choose">
                                        <span
                                            :class="
                                                statisticsStatus == 3
                                                    ? 'cur'
                                                    : ''
                                            "
                                            @click="tapChoose(3)"
                                            >月</span
                                        >
                                        <span
                                            :class="
                                                statisticsStatus == 2
                                                    ? 'cur'
                                                    : ''
                                            "
                                            @click="tapChoose(2)"
                                            >季度</span
                                        >
                                        <span
                                            :class="
                                                statisticsStatus == 1
                                                    ? 'cur'
                                                    : ''
                                            "
                                            @click="tapChoose(1)"
                                            >年</span
                                        >
                                    </p>
                                </div>
                                <el-table
                                    :header-cell-style="{
                                        background: '#e6e6e6',
                                        color: '#000',
                                    }"
                                    border
                                    :data="tableData"
                                    style="width: 100%"
                                >
                                    <el-table-column
                                        prop="connectTime"
                                        label="通话时间"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                        prop="outCall"
                                        label="通话类型"
                                        width="100"
                                    >
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.outCall == 0"
                                                >呼入</span
                                            >
                                            <span v-if="scope.row.outCall == 1"
                                                >呼出</span
                                            >
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="connectTimeLen"
                                        label="通话时长"
                                    >
                                    </el-table-column>

                                    <el-table-column
                                        show-overflow-tooltip="true"
                                        width="260"
                                        prop="remark"
                                        label="话务小结"
                                    >
                                    </el-table-column>
                                </el-table>
                                <el-pagination
                                    class="pages"
                                    background
                                    layout="total, prev, pager, next"
                                    @current-change="handleCurrentChange"
                                    :total="page.total"
                                    :current-page.sync="page.pageNo"
                                    :page-size="3"
                                >
                                </el-pagination>
                            </div>
                            <el-form-item label-width="0px" class="formBottom">
                                <el-button
                                    type="primary"
                                    @click="handleSave('ruleForm')"
                                    >确定</el-button
                                >
                                <el-button @click="handleClose">取消</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div class="mainRight">
                    <div class="oldTop">
                        <p class="oldTitle">基本信息</p>
                        <div class="oldHead">
                            <img
                                v-if="infos.photo"
                                :src="infos.photo"
                                class="oldPhoto"
                                alt=""
                            />
                            <img
                                v-else-if="
                                    infos.photo == null && infos.sex == '女'
                                "
                                :src="feMenSrc"
                                class="oldPhoto"
                                alt=""
                            />
                            <img
                                v-else-if="
                                    infos.photo == null && infos.sex == '男'
                                "
                                :src="manSrc"
                                class="oldPhoto"
                                alt=""
                            />

                            <ul class="oldName">
                                <li>姓名：{{ infos.name }}</li>
                                <li>{{ infos.phone }}</li>
                            </ul>
                        </div>
                        <div class="oldInfo">
                            <div class="oldConcat">
                                <div class="concatItem">
                                    性别：{{ infos.sex }}
                                </div>
                                <div class="concatItem">
                                    年龄：{{ infos.age }}
                                </div>
                            </div>
                            <div class="oldConcat">
                                性质：{{ infos.customerTypeDesc }}
                            </div>

                            <div class="oldConcat">
                                本月沟通次数：{{ infos.callCount }}次
                            </div>
                            <div class="oldConcat">
                                本月呼入接听统计：{{ infos.inCallCount }}次
                            </div>
                            <div class="oldConcat">
                                本月呼出接听数次：{{ infos.outCallCount }}次
                            </div>
                            <div class="oldConcat">
                                <el-button
                                    type="primary"
                                    size="small"
                                    @click="handleTableForm"
                                    >新建工单</el-button
                                >
                            </div>
                        </div>
                    </div>
                    <div class="oldBottom">
                        <p class="oldTitle">工单</p>
                        <p class="oldRed">
                            待服务：{{ infos.noFinishCount }}单
                        </p>
                        <p class="oldGreen">
                            已完成：{{ infos.finishCount }}单
                        </p>
                        <div class="oldServe">
                            <ul>
                                <li
                                    v-for="(item, index) in infos.objList"
                                    :key="index"
                                >
                                    {{ item.ensureName }}：{{
                                        item.finishCount
                                    }}单
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
        <VisitDialog
            ref="visitDialog"
            @updateList="updateList"
            :show-visit.sync="showVisit"
            :showTitle="showTitle"
            :orderInfo="orderInfo"
        ></VisitDialog>
    </div>
</template>
<script>
import request from "@/utils/request.js"
import VisitDialog from "../detailsInfo/component/visitDialog.vue"
export default {
    props: ["openData"],
    components: {
        VisitDialog,
    },
    data() {
        return {
            showVisit: false,
            showTitle: "",
            orderInfo: {
                customerName: "",
            },
            manSrc: require("../assets/img/boy.png"),
            feMenSrc: require("../assets/img/girl.png"),
            page: { pageNo: 1, pageSize: 3, total: 0 },
            tableData: [],
            contactList: [],
            infos: {},
            statisticsStatus: 3,
            dialogVisible: true,
            addForm: {
                remark: "",
                calltype: "",
                calltypedes: "",
                callid: "",
                callmanid: "",
                callman: "",
            },
            rules: {
                calltype: [
                    {
                        required: true,
                        message: "请选择沟通类型",
                        trigger: "change",
                    },
                ],
            },
        }
    },
    created() {
        this.getList()
        this.getData()
        this.getContact()

        this.addForm = {
            remark: "",
            calltype: "",
            calltypedes: "",
            callid: this.openData.callid,
            callmanid: this.openData.callmanid,
            callman: this.openData.callman,
        }
    },
    methods: {
        updateList() {},
        // 新建工单
        handleTableForm() {
            this.showTitle = "新增"
            this.showVisit = true
            // 获取服务类型
            this.$refs.visitDialog &&
                this.$refs.visitDialog.getServiceTypeList()
            // 获取套餐类型
            this.$refs.visitDialog.serverObj.customerName = this.infos.name
            this.$refs.visitDialog.serverObj.customerphone = this.openData.phone
            this.$refs.visitDialog.serverObj.address = this.infos.address
            this.$refs.visitDialog && this.$refs.visitDialog.getEnsureList()
        },
        // 沟通类型
        getContact() {
            request({
                url: "/jjyl/admin/communicationType/info/findList",
                method: "POST",
                data: {
                    pageNo: 1,
                    pageSize: 1000,
                    status: 1,
                },
            }).then((res) => {
                if (res.code == 200) {
                    if (!res.content) {
                        this.contactList = []
                    } else {
                        this.contactList = res.content.list || []
                        if (sessionStorage.getItem("phoneStart")) {
                            if (res.content.list.length > 0) {
                                res.content.list.forEach((item) => {
                                    if (
                                        item.id ==
                                        sessionStorage.getItem("phoneStart")
                                    ) {
                                        this.addForm.calltype = item.id
                                        this.addForm.calltypedes = item.name
                                        this.addForm.remark = item.content
                                        console.log(this.addForm, "数据")
                                    }
                                })
                            }
                        }
                    }
                }
            })
            // contactList
        },

        // 切换筛选
        tapChoose(index) {
            this.page.pageNo = 1
            this.statisticsStatus = index
            this.getList()
            this.$forceUpdate()
        },
        // 详情
        getData() {
            const self = this
            let length = self.openData.phone.length
            let aa = self.openData.phone.slice(1, 2)
            if (length == 12 && aa == "1") {
                self.openData.phone = self.openData.phone.substr(1)
            }
            console.log(self.openData.phone, "self.openData.phone")
            request({
                url: "/jjyl/traffic/callInfo/info/findInfoByPhone",
                method: "POST",
                data: {
                    phone: self.openData.phone,
                },
            }).then((res) => {
                if (res.code == "200") {
                    // console.log("数据", res.content)
                    if (res.content) {
                        self.infos = Object.assign(self.openData, res.content)
                    }
                }
            })
        },
        // 列表数据
        getList() {
            const self = this
            request({
                url: "/jjyl/traffic/callInfo/info/findList",
                method: "POST",
                data: {
                    phone: self.openData.phone,
                    statisticsStatus: self.statisticsStatus,
                    pageNo: self.page.pageNo,
                    pageSize: self.page.pageSize,
                },
            }).then((res) => {
                if (res.code == "200") {
                    if (!res.content) {
                        self.tableData = []
                        self.page.total = 0
                    } else {
                        self.tableData = []
                        self.tableData = res.content.list || []
                        self.page.total = res.content.count || 0
                        // console.log(self.page.total, "测试说")
                    }
                }
            })
        },
        // 分页
        handleCurrentChange(val) {
            this.page.pageNo = val
            this.getList()
        },
        handleSizeChange() {
            this.page.pageSize = val
            this.getList()
        },
        // 关闭
        handleClose() {
            this.$refs.ruleForm.resetFields()
            this.$emit("contactTap", false)
        },
        // 保存
        handleSave(formName) {
            const self = this
            self.$refs[formName].validate((valid) => {
                if (valid) {
                    // this.$emit("contactTap", true)
                    if (valid) {
                        self.addForm.calltypedes =
                            self.$refs.selectType.selectedLabel
                        let data = {
                            ...self.addForm,
                        }
                        // console.log(self.addForm, "数据")
                        request({
                            url: "/jjyl/traffic/callInfo/info/updateSummary",
                            method: "POST",
                            data: data,
                        }).then((res) => {
                            if (res.code == 200) {
                                self.$message.success(res.message)
                                self.$emit("contactTap", true)
                            } else {
                                self.$message.error(res.message)
                            }
                        })
                    }
                } else {
                    self.$message.error("请按要求输入")
                    return false
                }
            })
        },
    },
}
</script>
<style scoped lang="less">
/deep/.el-dialog__body {
    padding: 10px 25px !important;
}
.icon {
    position: absolute;
    width: 34px;
    height: 30px;
    left: 15px;
    top: 15px;
}
.mainBox {
    display: flex;
    height: 540px;
    border-top: 1px solid #f2f3f4;
    .mainLeft {
        flex: 1;
        margin-right: 15px;
        .demo-ruleForm {
            margin-top: 15px;
        }
        .formBottom {
            text-align: center;
        }
        .chooseTab {
            margin-bottom: 15px;
            display: flex;
            justify-content: center;
            align-content: center;
            .name {
                flex: 1;
                font-size: 16px;
                line-height: 22px;
            }
            .choose {
                cursor: pointer;
                color: #fff;
                span {
                    display: inline-block;
                    border-radius: 4px;
                    padding: 0px 12px;
                    &.cur {
                        background: #1ab394;
                    }
                }
                border-radius: 4px;
                line-height: 22px;
                background: #d5d5d5;
            }
        }
        .pages {
            margin: 15px 0;
        }
    }
    .mainRight {
        width: 195px;
        border-left: 1px solid #f2f3f4;
        padding-left: 15px;
        .oldTitle {
            color: #282828;
            font-size: 16px;
            padding-top: 10px;
        }
        .oldTop {
            height: 260px;
            margin-bottom: 10px;
            border-bottom: 1px solid #f2f3f4;
            .oldHead {
                display: flex;
                justify-content: center;
                align-content: center;
                padding-top: 10px;
                .oldPhoto {
                    width: 42px;
                    height: 42px;
                    border-radius: 50%;
                }
                .oldName {
                    color: rgba(0, 0, 0, 0.65);
                    font-size: 14px;
                    line-height: 24px;
                    margin-left: 10px;
                    flex: 1;
                }
            }
            .oldInfo {
                padding-top: 10px;
                .oldConcat {
                    display: flex;
                    color: rgba(0, 0, 0, 0.65);
                    line-height: 24px;
                    font-size: 14px;
                    .concatItem {
                        flex: 1;
                    }
                }
            }
        }
        .oldBottom {
            .oldRed {
                color: #ed5565;
                padding-top: 12px;
                line-height: 24px;
            }
            .oldGreen {
                color: #1ab394;
                padding-top: 12px;
                line-height: 24px;
            }
            .oldServe {
                overflow: scroll;
                height: 160px;
                color: #474747;
                font-size: 12px;
                line-height: 23px;
                margin-top: 15px;
            }
        }
    }
}
</style>